import { FC, useState } from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
  font-size: 12px;
`;

const Toggle = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 10px;
  background: #f8fafc;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #64748b;
  text-align: left;

  &:hover {
    background: #f1f5f9;
  }
`;

const Arrow = styled.span<{ open: boolean }>`
  display: inline-block;
  transition: transform 0.15s ease;
  transform: rotate(${({ open }) => (open ? "90deg" : "0deg")});
  font-size: 10px;
`;

const Pre = styled.pre`
  margin: 0;
  padding: 10px;
  background: #fff;
  overflow-x: auto;
  font-size: 11px;
  line-height: 1.5;
  font-family: "Berkeley Mono Variable", monospace;
  border-top: 1px solid #e2e8f0;
`;

interface JsonInspectorProps {
  data: unknown;
  label?: string;
  defaultOpen?: boolean;
}

export const JsonInspector: FC<JsonInspectorProps> = ({
  data,
  label = "Details",
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  if (data === null || data === undefined) return null;

  const text = typeof data === "string" ? data : JSON.stringify(data, null, 2);

  return (
    <Container>
      <Toggle onClick={() => setOpen(!open)}>
        <Arrow open={open}>&#x25B6;</Arrow>
        {label}
      </Toggle>
      {open && <Pre>{text}</Pre>}
    </Container>
  );
};
